export type ComparisonSide = "before" | "after";

export const valueIntent = (side: ComparisonSide | undefined) => (side === "before" ? "muted" : undefined);

export const changedValueClassName = (side: ComparisonSide | undefined, changed: boolean) =>
	side === "before" && changed ? "line-through" : undefined;
